import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

import { useGlobalModal } from "../../components/Contexts/GlobalModalContext";
import { ModalActions } from "../../components/Modals/ModalActions";
import { Button } from "../../components/Buttons/Button";
import i18n from "../../i18n";

type ConfirmSetAvailableModalProps = {
  machineName: string
  handleSetAvailable: () => void
}

const ConfirmSetAvailableModal: React.FC<ConfirmSetAvailableModalProps> = ({ machineName, handleSetAvailable }) => {
  const { t } = useTranslation("stoppages");
  const { hideModal } = useGlobalModal();

  return (
    <form>
      <div>
        <h2 className="border-b border-theme-border font-semibold pb-2 mb-8 text-[1.6rem] text-theme-text">
          {t("setAvailable.title", { machine: machineName })}
          <FontAwesomeIcon icon={faSpinner} spin
            className={`text-theme-text text-sm transition ease-out mb-2 ml-1`} />
        </h2>
        <p className="text-theme-text">{t("setAvailable.body")}</p>
      </div>
      <ModalActions className="!mt-12">
        <Button variant="muted" className="!text-theme-text" onClick={hideModal}>
          {i18n.t("actions.cancel")}
        </Button>
        <Button variant="success" isDefaultAction mnemonic="c" onClick={handleSetAvailable}>
          {i18n.t("actions.confirm")}
        </Button>
      </ModalActions>
    </form>
  )
}

export default ConfirmSetAvailableModal